import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-connected',
  templateUrl: './loading-connected.component.html',
  styleUrls: ['./loading-connected.component.scss']
})
export class LoadingConnectedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
